import { products } from '@/types/License';
import { defineComponent } from 'vue';
export default defineComponent({
    name: 'CompanySelector',
    props: {
        value: Number,
        rules: Array
    },
    setup(props, { emit }) {
        return {
            items: products.map(product => {
                return {
                    text: product.name,
                    value: product.seq
                };
            }),
            input(value) {
                emit('input', value);
            }
        };
    }
});
